/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Categorizes the type of product or service for tax purposes. This helps determine the applicable tax rules based on the nature of the item or service.
 */
export const TaxCategory = {
  Saas: "saas",
  DigitalGoodsService: "digital-goods-service",
  Ebooks: "ebooks",
} as const;
/**
 * Categorizes the type of product or service for tax purposes. This helps determine the applicable tax rules based on the nature of the item or service.
 */
export type TaxCategory = ClosedEnum<typeof TaxCategory>;

/** @internal */
export const TaxCategory$inboundSchema: z.ZodNativeEnum<typeof TaxCategory> = z
  .nativeEnum(TaxCategory);
/** @internal */
export const TaxCategory$outboundSchema: z.ZodNativeEnum<typeof TaxCategory> =
  TaxCategory$inboundSchema;
